<template>
  <div class="form-check form-switch d-flex justify-content-center align-items-center">
    <input
      v-model="checked"
      class="form-check-input ms-input"
      type="checkbox"
      :id="id"
      @change="emit('value-changed', checked)"
    />
    <label class="NKT-P2" :for="id">{{ text }}</label>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, onMounted } from 'vue'

const emit = defineEmits(['value-changed'])

var checked = ref<boolean>()

var props = defineProps({
  checked: Boolean,
  id: String,
  text: String
})

onMounted(() => {
  checked.value = props.checked
})
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.ms-switch-bar {
  gap: 16px;
}

.ms-input {
  width: 24px;
  height: 12px;
  margin-top: 2px;
  margin-right: 8px;
}

.form-check-input {
  background-color: color.$color-medium-grey;
  border-color: color.$color-medium-grey;
}

.form-check {
  margin: 0;
}

.form-check-input:checked {
  background-color: color.$color-nordic-blue-base;
  border-color: color.$color-nordic-blue-base;
}

.form-check-input:disabled {
  background-color: color.$color-dark-grey;
  border-color: color.$color-dark-grey;
}

.form-check-input:focus:not(:checked) {
  background-color: color.$color-medium-grey;
}
</style>
